// src/services/locationsService.js
import api from './api';

// Destinations API functions
const getDestinations = async (filters = {}, page = 1, per_page = 50) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      ...filters
    });

    console.log('Calling API:', `/api/admin/locations/destinations?${params}`);
    const response = await api.get(`/api/admin/locations/destinations?${params}`);
    console.log('Raw API response:', response);
    console.log('Response data:', response.data);
    console.log('Response type:', typeof response.data);
    console.log('Is array:', Array.isArray(response.data));
    
    return response;
  } catch (error) {
    console.error('Get destinations error:', error);
    console.error('Error response:', error.response);
    throw new Error(error.message || 'Failed to fetch destinations');
  }
};

const getDestinationById = async (id) => {
  try {
    const response = await api.get(`/api/admin/locations/destinations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Get destination by ID error:', error);
    throw new Error(error.message || 'Failed to fetch destination details');
  }
};

const createDestination = async (destinationData) => {
  try {
    const response = await api.post('/api/admin/locations/destinations', destinationData);
    return response.data;
  } catch (error) {
    console.error('Create destination error:', error);
    throw new Error(error.message || 'Failed to create destination');
  }
};

const updateDestination = async (id, destinationData) => {
  try {
    const response = await api.put(`/api/admin/locations/destinations/${id}`, destinationData);
    return response.data;
  } catch (error) {
    console.error('Update destination error:', error);
    throw new Error(error.message || 'Failed to update destination');
  }
};

const deleteDestination = async (id) => {
  try {
    const response = await api.delete(`/api/admin/locations/destinations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Delete destination error:', error);
    throw new Error(error.message || 'Failed to delete destination');
  }
};

const updateDestinationStatus = async (id, is_active) => {
  try {
    const response = await api.put(`/api/admin/locations/destinations/${id}/status`, { is_active });
    return response.data;
  } catch (error) {
    console.error('Update destination status error:', error);
    throw new Error(error.message || 'Failed to update destination status');
  }
};

const bulkDeleteDestinations = async (ids) => {
  try {
    const response = await api.delete('/api/admin/locations/destinations/bulk', { data: { ids } });
    return response.data;
  } catch (error) {
    console.error('Bulk delete destinations error:', error);
    throw new Error(error.message || 'Failed to delete destinations');
  }
};

const updateDestinationOrder = async (orderedDestinations) => {
  try {
    const response = await api.put('/api/admin/locations/destinations/order', { 
      destinations: orderedDestinations 
    });
    return response.data;
  } catch (error) {
    console.error('Update destination order error:', error);
    throw new Error(error.message || 'Failed to update destination order');
  }
};

// Sub-destinations API functions
const getSubDestinations = async (filters = {}, page = 1, per_page = 50) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      ...filters
    });

    const response = await api.get(`/api/admin/locations/sub-destinations?${params}`);
    return response;
  } catch (error) {
    console.error('Get sub destinations error:', error);
    throw new Error(error.message || 'Failed to fetch sub destinations');
  }
};

const getSubDestinationsByDestination = async (destinationId, filters = {}) => {
  try {
    const params = new URLSearchParams({
      destination_id: destinationId,
      ...filters
    });

    console.log('Calling sub-destinations API:', `/api/admin/locations/sub-destinations?${params}`);
    const response = await api.get(`/api/admin/locations/sub-destinations?${params}`);
    console.log('Sub-destinations response:', response);
    console.log('Sub-destinations data:', response.data);
    console.log('Sub-destinations data type:', typeof response.data);
    console.log('Sub-destinations is array:', Array.isArray(response.data));
    
    return response;
  } catch (error) {
    console.error('Get sub destinations by destination error:', error);
    console.error('Error response:', error.response);
    throw new Error(error.message || 'Failed to fetch sub destinations for destination');
  }
};

const getSubDestinationById = async (id) => {
  try {
    const response = await api.get(`/api/admin/locations/sub-destinations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Get sub destination by ID error:', error);
    throw new Error(error.message || 'Failed to fetch sub destination details');
  }
};

const createSubDestination = async (subDestinationData) => {
  try {
    const response = await api.post('/api/admin/locations/sub-destinations', subDestinationData);
    return response.data;
  } catch (error) {
    console.error('Create sub destination error:', error);
    throw new Error(error.message || 'Failed to create sub destination');
  }
};

const updateSubDestination = async (id, subDestinationData) => {
  try {
    const response = await api.put(`/api/admin/locations/sub-destinations/${id}`, subDestinationData);
    return response.data;
  } catch (error) {
    console.error('Update sub destination error:', error);
    throw new Error(error.message || 'Failed to update sub destination');
  }
};

const deleteSubDestination = async (id) => {
  try {
    const response = await api.delete(`/api/admin/locations/sub-destinations/${id}`);
    return response.data;
  } catch (error) {
    console.error('Delete sub destination error:', error);
    throw new Error(error.message || 'Failed to delete sub destination');
  }
};

const updateSubDestinationStatus = async (id, is_active) => {
  try {
    const response = await api.put(`/api/admin/locations/sub-destinations/${id}/status`, { is_active });
    return response.data;
  } catch (error) {
    console.error('Update sub destination status error:', error);
    throw new Error(error.message || 'Failed to update sub destination status');
  }
};

const bulkDeleteSubDestinations = async (ids) => {
  try {
    const response = await api.delete('/api/admin/locations/sub-destinations/bulk', { data: { ids } });
    return response.data;
  } catch (error) {
    console.error('Bulk delete sub destinations error:', error);
    throw new Error(error.message || 'Failed to delete sub destinations');
  }
};

const updateSubDestinationOrder = async (orderedSubDestinations) => {
  try {
    const response = await api.put('/api/admin/locations/sub-destinations/order', { 
      sub_destinations: orderedSubDestinations 
    });
    return response.data;
  } catch (error) {
    console.error('Update sub destination order error:', error);
    throw new Error(error.message || 'Failed to update sub destination order');
  }
};

const getLocationStats = async () => {
  try {
    const response = await api.get('/api/admin/locations/stats');
    return response.data;
  } catch (error) {
    console.error('Get location stats error:', error);
    throw new Error(error.message || 'Failed to fetch location statistics');
  }
};

// Export all functions
export {
  getDestinations,
  getDestinationById,
  createDestination,
  updateDestination,
  deleteDestination,
  updateDestinationStatus,
  bulkDeleteDestinations,
  updateDestinationOrder,
  getSubDestinations,
  getSubDestinationsByDestination,
  getSubDestinationById,
  createSubDestination,
  updateSubDestination,
  deleteSubDestination,
  updateSubDestinationStatus,
  bulkDeleteSubDestinations,
  updateSubDestinationOrder,
  getLocationStats
};

// Default export for convenience
export default {
  getDestinations,
  getDestinationById,
  createDestination,
  updateDestination,
  deleteDestination,
  updateDestinationStatus,
  bulkDeleteDestinations,
  updateDestinationOrder,
  getSubDestinations,
  getSubDestinationsByDestination,
  getSubDestinationById,
  createSubDestination,
  updateSubDestination,
  deleteSubDestination,
  updateSubDestinationStatus,
  bulkDeleteSubDestinations,
  updateSubDestinationOrder,
  getLocationStats
};
